var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrosoft = function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F35325",
    d: "M.5.139h11.428v11.428H.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#81BC06",
    d: "M13.072.139H24.5v11.428H13.072z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#05A6F0",
    d: "M.5 12.71h11.428v11.428H.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA08",
    d: "M13.072 12.71H24.5v11.428H13.072z"
  })));
};
export default SvgMicrosoft;